import { render, staticRenderFns } from "./CMobileSearch.vue?vue&type=template&id=45412328&scoped=true"
import script from "./CMobileSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./CMobileSearch.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CMobileSearch.vue?vue&type=style&index=0&id=45412328&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45412328",
  null
  
)

export default component.exports